Librarian.Modules.Link = new Class({
    Extends: Librarian.Modules.Module,

    options: {
        classPrefix: "modules-link-",
        link: null,
        label: null,
    },

    initialize: function(options, wrapperEl) {
        this.setOptions(options);
        this.parent(this.options, wrapperEl);
    },

    load: function() {
        if (!this.wrapperEl)
            return;

        this.parent();

        // add onClick function to wrapperEl open new tab
        this.wrapperEl.addClass("nav-wrapper");
        this.wrapperEl.addOnClick(function() {
            var newTab = window.open(this.options.link, '_blank');
            newTab.focus();
        }.bind(this));
      
        var label = (this.options.label || '').trim();
        if (label.length > 0) {
            new Element("div", {
                "class": "nav-label",
                "html": label
            }).injectInside(this.containerEl);
        }
    }
});